import React, { useContext, useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataContext } from '../../contexto/ContextoDatos';
import styles from './InterfazUI.module.css';

export const SearchBar = () => {
  const { searchQuery, setSearchQuery, searchResults } = useContext(DataContext);
  const [isOpen, setIsOpen] = useState(false);
  const searchRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleResultClick = (result) => {
    setIsOpen(false);
    setSearchQuery('');
    if (result.type === 'service') {
      navigate(`/servicios/${result.slug}`);
    } else if (result.type === 'product_category') {
      navigate(`/productos?categoria=${result.slug}`);
    } else if (result.type === 'product') {
      navigate(`/productos/${result.slug}`);
    } else if (result.type === 'section') {
      if (result.anchor) {
        if (window.location.pathname === '/') {
          const el = document.getElementById(result.anchor);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        } else {
          navigate('/');
          setTimeout(() => {
            const el = document.getElementById(result.anchor);
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }, 400);
        }
      } else {
        navigate(result.path);
      }
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
  };

  const getBadgeClass = (type) => {
    switch (type) {
      case 'product_category': return styles.badgeCategory;
      case 'product': return styles.badgeProduct;
      case 'service': return styles.badgeService;
      case 'section': return styles.badgeSection;
      default: return styles.badgeSection;
    }
  };

  return (
    <div className={styles.searchContainer} ref={searchRef}>
      <form onSubmit={handleSearchSubmit} className={styles.searchForm}>
        <input
          type="text"
          placeholder="Buscar en SEIMA..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setIsOpen(true);
          }}
          onFocus={() => setIsOpen(true)}
          className={styles.searchInput}
        />
        <button type="submit" className={styles.searchButton} aria-label="Search">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" width="18" height="18">
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
          </svg>
        </button>
      </form>

      {isOpen && searchQuery.trim() && (
        <div className={styles.searchResultsDropdown}>
          {searchResults.length > 0 ? (
            <ul className={styles.resultsList}>
              {searchResults.slice(0, 7).map((result) => (
                <li
                  key={`${result.type}-${result.id}`}
                  onClick={() => handleResultClick(result)}
                  className={styles.resultItem}
                >
                  <div className={styles.resultDetails}>
                    <span className={styles.resultName}>{result.name}</span>
                    <div>
                      <span className={`${styles.badge} ${getBadgeClass(result.type)}`}>
                        {result.category}
                      </span>
                    </div>
                  </div>
                  <span className={styles.arrowIcon}>→</span>
                </li>
              ))}
            </ul>
          ) : (
            <div className={styles.noResults}>Sin coincidencias para "{searchQuery}"</div>
          )}
        </div>
      )}
    </div>
  );
};
export default SearchBar;
